module.exports = __webpack_public_path__ + "img/svg/user-game-level-separator.3d484315575c54e4733412c5130f1376.svg";